import React from 'react';
import styled from 'styled-components';

const Title = styled.h1`
  font-size: 27px;
  font-weight: 600;
  letter-spacing: -0.3px;
  color: #494c48;
  margin: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  @media (max-width: 520px) {
    display: none;
  }
`;

const PageHeader = () => (
  <Wrapper>
    <Title>Transactions</Title>
  </Wrapper>
);

export default PageHeader;
